import React from 'react';
import { Helmet } from 'react-helmet-async';

export function NotFoundPage() {
  return (
    <div className="NotFoundPage">
      <Helmet>
        <title>404 Not Found</title>
      </Helmet>
      ページが見つかりませんでした。
    </div>
  );
}

export default NotFoundPage;
